<template>
	<div>
		<right-panel :datas="connects" ref="rightPanel" @onClose="onCloseForm" @onSubmit="onSubmitForm">
			<div slot="header">
				<translate>Configuration File</translate>
			</div>
			<div slot="content" class="wrapper-padding">
				<el-form ref="addForm" :model="addForm" label-width="120px" label-suffix="：">
					<el-form-item :label="attrText.configurationFile"> agent_config.yaml </el-form-item>
					<el-form-item :label="attrText.updateTime">
						<span v-if="connects">
							{{ (addForm.update_time * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}
						</span>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="detail-btn flex items-center" style="justify-content: space-around">
				<el-button v-loading="isPolling" :disabled="isPolling" type="primary" @click="toExport()">
					<translate>Export</translate>
				</el-button>
				<el-upload :disabled="isPolling" v-if="connects" class="upload-demo" :action="`${baseUrl.apiUrl}/agent/config/import`" :data="{ network_id: connects.info.id }" :show-file-list="false" :on-success="importAndRestart" :on-error="importError" :file-list="fileList">
					<el-button v-loading="isPolling" size="primary" type="primary">
						<translate>Import And Restart</translate>
					</el-button>
				</el-upload>
				<el-button @click="onCloseForm()">
					<translate>Cancel</translate>
				</el-button>
			</div>
		</right-panel>
	</div>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import { Utils, baseUrl } from '../../../config'
import Polling from '../../../plugins/polling'

export default {
	name: 'ClusterConfigFile',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			addForm: {
				ipAddress: '',
			},
			isPolling: false, // 是否正在轮询
			isPaused: false, // 轮询是否暂停
			fileList: [],
		}
	},
	computed: {
		attrText() {
			return this.translateText()
		},
		baseUrl() {
			return baseUrl
		},
		// 新增：从Vuex获取全局轮询实例
		pollingInstance() {
			return this.$store.state.cluster.configPollingInstance
		},
	},
	created() {
		// 新增：组件创建时，同步全局轮询的状态
		if (this.pollingInstance) {
			this.isPolling = true
		}
	},
	methods: {
		translateText() {
			return {
				configurationFile: this.$gettext('Configuration File'),
				updateTime: this.$gettext('Update Time'),
			}
		},

		// 轮询导入导出结果
		async pollingClusterConfig(params) {
			return this.$store.dispatch(STORE_CONST.CLUSTER.POLLING_CLUSTER_CONFIG, { task_id: params.task_id }).then((res) => {
				return res
			})
		},

		toExport() {
			this.$store
				.dispatch(STORE_CONST.CLUSTER.EXPORT_CLUSTER_CONFIG, {
					network_id: this.connects.info.id,
				})
				.then((res) => {
					// 步骤1：如果已有全局轮询实例，先停止（避免重复轮询）
					if (this.pollingInstance) {
						this.pollingInstance.stop()
					}
					const newPolling = new Polling({
						interval: 1000 * 3,
						maxRetry: 3,
						requestFn: this.pollingClusterConfig,
						requestFnParams: {
							task_id: res.task_id,
						},

						// 请求成功回调
						onSuccess: (result) => {
							this.isPolling = true
							this.isPaused = false
							console.log('轮询获取状态：', result)
							if (result.result) {
								window.open(`${baseUrl.apiUrl}/agent/config/query?task_id=${res.task_id}&download=1`, '_blank')
								// 成功后停止轮询，并清空全局实例
								newPolling.stop()
								this.$store.commit(STORE_CONST.CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE)
								this.isPolling = false
							}
						},
						// 请求失败回调
						onError: (error) => {
							console.error('轮询请求失败：', error)
							// 失败后清空全局实例
							this.$store.commit(STORE_CONST.CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE)
							this.isPolling = false
						},
						// 轮询完成/停止回调
						onComplete: () => {
							this.isPolling = false
							this.isPaused = false
							console.log('轮询已停止')
							// 完成后清空全局实例
							this.$store.commit(STORE_CONST.CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE)
						},
					})
					// 步骤3：启动轮询，并将实例存入Vuex
					newPolling.start()
					this.$store.commit(STORE_CONST.CLUSTER.SET_CONFIG_POLLING_INSTANCE, newPolling)
					this.isPolling = true
				})
		},
		importAndRestart(response, file) {
			console.log(response, 'response')
			// 步骤1：如果已有全局轮询实例，先停止（避免重复轮询）
			if (this.pollingInstance) {
				this.pollingInstance.stop()
			}
			const newPolling = new Polling({
				interval: 1000 * 3,
				maxRetry: 3,
				requestFn: this.pollingClusterConfig,
				requestFnParams: {
					task_id: response.task_id,
				},

				// 请求成功回调
				onSuccess: (result) => {
					this.isPolling = true
					this.isPaused = false
					console.log('轮询获取状态：', result)
					if (result.result) {
						// 成功后停止轮询，并清空全局实例
						newPolling.stop()
						this.$store.commit(STORE_CONST.CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE)
						this.$notify({
							message: this.$gettext('Update successfully!'),
							type: 'success',
						})
						this.$emit('onClosePanel')
						this.connects.callback()
					}
				},
				// 请求失败回调
				onError: (error) => {
					console.error('轮询请求失败：', error)
					this.$store.commit(STORE_CONST.CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE)
					this.isPolling = false
				},
				// 轮询完成/停止回调
				onComplete: () => {
					this.isPolling = false
					this.isPaused = false
					console.log('轮询已停止')
					// 完成后清空全局实例
					this.$store.commit(STORE_CONST.CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE)
				},
			})
			// 步骤3：启动轮询，并将实例存入Vuex
			newPolling.start()
			this.$store.commit(STORE_CONST.CLUSTER.SET_CONFIG_POLLING_INSTANCE, newPolling)
			this.isPolling = true
		},
		importError(err) {
			console.log(err.message, 'err')
			if (err.message.includes('FileTypeError')) {
				this.$notify({
					message: this.$gettext('File Format Error'),
					type: 'error',
				})
			}
			if (err.message.includes('NetworkNotFound')) {
				this.$notify({
					message: this.$gettext('Cluster Does Not Exist'),
					type: 'error',
				})
			}
			if (err.message.includes('AgentNotFound')) {
				this.$notify({
					message: this.$gettext('Node Not Bound Or Does Not Exist'),
					type: 'error',
				})
			}
		},

		onSubmitForm() {},
		onCloseForm() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				this.connects = this.items
				this.addForm.update_time = this.items.info.agent.update_time
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss"></style>



// WEBPACK FOOTER //
// cluster-config-file.vue?eae687f4